export default __webpack_public_path__ + "static/media/map.1eb23496.png";